import { HTTP } from "./http-common";

const passportAPI = {
  updatePassports(passports) {
    return HTTP.put(`/passport`, {
      passports,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CV1] Oops! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },
};

export default passportAPI;



// WEBPACK FOOTER //
// ./src/api/passport.js